import {ScreenVo} from '../../common/shared/api/karina/vo/menu/ScreenVo.interface';
import {Screen} from '../generated/types';
import {createAgeGrade} from './AgeGrade';
import {createStaticLandingType} from './StaticLandingType';

export function createScreen(screenVo: ScreenVo): Screen {
  return {
    id: `screen-${screenVo.uid}`,
    uid: screenVo.uid,
    title: screenVo.title,
    type: screenVo.type,
    landingType: createStaticLandingType(screenVo.landing_type),
    categoryUid: screenVo.category_uid,
    ageGrade: screenVo.age_grade
      ? createAgeGrade(screenVo.age_grade)
      : undefined,
    icon: screenVo.icon,
  };
}
